import React, { useState } from 'react';
import './Login.css';

const Login = () => {
  // form state
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  // error state
  const [errors, setErrors] = useState({});
  // loading state (if you want to indicate API call in progress)
  const [loading, setLoading] = useState(false);

  // basic validation function
  const validate = () => {
    const newErrors = {};
    // Simple email regex for validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(email)) {
      newErrors.email = 'Enter a valid email';
    }
    
    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);
    
    // if no errors, proceed to call your backend
    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      
      // Example API call; replace with your backend endpoint
      try {
        const response = await fetch('/api/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email, password })
        });
        
        const data = await response.json();
        setLoading(false);
        
        if (response.ok) {
          // Handle successful login (for example, save token and redirect)
          console.log('Login successful', data);
        } else {
          // Handle errors returned from backend
          setErrors({ form: data.message || 'Login failed' });
        }
      } catch (err) {
        console.error('Login error:', err);
        setErrors({ form: 'Something went wrong, please try again.' });
        setLoading(false);
      }
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit} noValidate>
        <h2>Login</h2>
        
        {errors.form && <div className="error form-error">{errors.form}</div>}
        
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input 
            type="email" 
            id="email" 
            placeholder="Enter your email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            className={errors.email ? 'input-error' : ''}
          />
          {errors.email && <div className="error">{errors.email}</div>}
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input 
            type="password" 
            id="password" 
            placeholder="Enter your password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            className={errors.password ? 'input-error' : ''}
          />
          {errors.password && <div className="error">{errors.password}</div>}
        </div>
        
        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default Login;
